import React from "react";

export interface BackToMainPageProps {}

export interface BackToMainPageState {}

export const BackToMainPage = (props: BackToMainPageProps) => {
  return (
    <div className="text-center">
      <a href="/" className="back-to-main">
        powrót do strony głównej {">>"}
      </a>
    </div>
  );
};

export default BackToMainPage;
